import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiTarget, FiTrendingUp } = FiIcons;

const Blueprint = () => {
  const phases = [
    {
      phase: "A",
      title: "Story & Credibility",
      dates: "15 Aug – 15 Sep",
      goal: "Launch magnetic narrative; open up 6-7 funnel",
      target: "$1.5M (3 new UHW gifts @ $500k)",
      tactics: [
        "10-min documentary premiere (private & public)",
        "Flagship 2-min promo reel across socials",
        "PR push in Greek & Québec press"
      ]
    },
    {
      phase: "B",
      title: "Broad Awareness Burst",
      dates: "16 Sep – 31 Oct",
      goal: "Build social proof & donor pipeline",
      target: "$2M (mix of $5k-$50k pledges)",
      tactics: [
        "Digital Burst Campaign #1 (ads + organic)",
        "Construction site webinar with live Q&A",
        "Grant deck submission (HHT + gov)"
      ]
    },
    {
      phase: "C",
      title: "Major-Gift Cultivation",
      dates: "1 Nov – 30 Nov",
      goal: "Secure anchor pledges before year-end",
      target: "$3M (5 donors @ $600k)",
      tactics: [
        "Major-Donor Preview Dinner (25 pax)",
        "1-to-1 tour videos & bespoke pitch decks",
        "Board peer-solicitation calls"
      ]
    },
    {
      phase: "D",
      title: "Community & Matching",
      dates: "1 Dec – 15 Jan",
      goal: "Mobilise diaspora & CSR matches",
      target: "$2M",
      tactics: [
        "Winter Gala hybrid livestream (pledge paddles + online giving thermometer)",
        "Paid Retargeting Burst (Dec) for lapsed visitors",
        "'12 Days of Giving' micro-donation drive ($50 avg.)"
      ]
    },
    {
      phase: "E",
      title: "Momentum Close-Out",
      dates: "16 Jan – 15 Mar",
      goal: "Finish gap; pledge fulfilment",
      target: "$3.5M",
      tactics: [
        "Impact montage release + pledge reminder",
        "Virtual Tele-thon (late Feb) featuring choir & farm footage",
        "Corporate breakfast webinars (CSR ESG pitch)"
      ]
    }
  ];

  const totalTarget = phases.reduce((sum, phase) => {
    const amount = parseFloat(phase.target.replace(/[^0-9.]/g, ''));
    return sum + amount;
  }, 0);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <SafeIcon icon={FiCalendar} className="w-12 h-12 mx-auto text-[#FF5F1F] mb-4" />
          <h2 className="text-3xl font-bold text-black mb-4">Seven-Month Fundraising Blueprint</h2>
        </div>

        <div className="space-y-8">
          {phases.map((phase, index) => (
            <div key={phase.phase} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-[#FF5F1F] to-orange-600 text-white p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <span className="bg-white text-[#FF5F1F] rounded-full w-12 h-12 flex items-center justify-center font-bold text-xl">
                      {phase.phase}
                    </span>
                    <div>
                      <h3 className="text-xl font-bold">{phase.title}</h3>
                      <p className="opacity-90">{phase.dates}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="flex items-center text-yellow-300">
                      <SafeIcon icon={FiTarget} className="w-5 h-5 mr-2" />
                      <span className="text-2xl font-bold">{phase.target}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                      <SafeIcon icon={FiTrendingUp} className="w-5 h-5 mr-2 text-[#FF5F1F]" />
                      Primary Goal
                    </h4>
                    <p className="text-gray-700">{phase.goal}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Core Tactics</h4>
                    <ul className="space-y-1">
                      {phase.tactics.map((tactic, tacticIndex) => (
                        <li key={tacticIndex} className="text-gray-700 text-sm flex items-start">
                          <span className="text-[#FF5F1F] mr-2">•</span>
                          {tactic}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-black text-white rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Campaign Summary</h3>
          <p className="text-lg mb-2">
            <strong>Subtotal:</strong> ${totalTarget}M target met by 15 Mar 2026
          </p>
          <p className="text-sm opacity-80">
            (with ~$500k cushion for overrun or maintenance fund)
          </p>
        </div>
      </div>
    </section>
  );
};

export default Blueprint;